var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m7.908 0 .086.001a.73.73 0 0 1 .329.109l.076.052.061.057a.757.757 0 0 1 .072.912l-.05.069-.064.074-.444.419c2.815.406 5.126 2.529 5.817 5.378l.044.191.037.185c.618 3.284-1.051 6.573-4.029 7.933-2.98 1.36-6.48.426-8.44-2.251-1.956-2.674-1.858-6.38.237-8.94a.727.727 0 0 1 1.041-.094.759.759 0 0 1 .09 1.051 5.82 5.82 0 0 0-.167 7.108c1.564 2.114 4.341 2.833 6.69 1.732 2.352-1.103 3.649-3.736 3.12-6.341-.447-2.201-2.095-3.884-4.154-4.378l-.177-.04-.079-.015.506.476a.76.76 0 0 1 .155.886l-.04.072-.049.068-.02.023a.725.725 0 0 1-.981.103l-.063-.054L5.61 2.997l-.11-.094-.043-.048-.035-.058-.02-.046-.02-.055-.015-.06-.008-.042a.705.705 0 0 1-.009-.096V2.44l.005-.058.01-.06.02-.076.02-.057.053-.092.134-.16L7.394.248a.732.732 0 0 1 .43-.24L7.908 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterArrow);
export default __webpack_public_path__ + "static/media/filter-arrow.9adf20532a6173ac284f576ecd5aa385.svg";
export { ForwardRef as ReactComponent };